import { render, staticRenderFns } from "./FabricCalculationInfo.vue?vue&type=template&id=cdc142b0&scoped=true"
import script from "./FabricCalculationInfo.vue?vue&type=script&lang=js"
export * from "./FabricCalculationInfo.vue?vue&type=script&lang=js"
import style0 from "./FabricCalculationInfo.vue?vue&type=style&index=0&id=cdc142b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc142b0",
  null
  
)

export default component.exports